import {useEffect, useState} from "react";
import {TbPlayerPause, TbPlayerPlay} from "react-icons/tb";

import {ButtonWithMutationAndConfirmationDialog} from "@/components/ButtonWithMutationAndConfirmationDialog/ButtonWithMutationAndConfirmationDialog.tsx";
import {RadioGroup} from "@/components/form/RadioGroup.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {GQL_CHECK_DETAILS, GQL_UPDATE_CHECK_IS_PAUSED} from "@/lib/queries/checks.ts";

interface CheckPauseResumeActionProps {
  id: number;
  isPaused: boolean;
  isUp: boolean;
}

export const CheckPauseResumeAction = ({id, isPaused, isUp}: CheckPauseResumeActionProps) => {
  const hasOngoingAlert = !isPaused && !isUp;
  const [sendResolvedNotifications, setSendResolvedNotifications] = useState("true");
  useEffect(() => {
    setSendResolvedNotifications("true");
  }, [hasOngoingAlert]);

  return (
    <ButtonWithMutationAndConfirmationDialog
      buttonVariant="secondary"
      buttonSize="extraSmall"
      tooltip={false}
      dialogTitle={
        hasOngoingAlert ? "Confirm Pause and Resolve Notification?" : isPaused ? "Resume Check" : "Pause Check"
      }
      dialogSize={hasOngoingAlert ? "lg" : undefined}
      dialogElement={
        isPaused ? (
          <p>Are you sure you want to Resume monitoring for this Check?</p>
        ) : (
          <div className="px-lg-4 py-lg-4">
            <p>Pausing the Check will stop monitoring and no further updates from the Check will be sent.</p>
            {hasOngoingAlert && (
              <>
                <p>Would you like to send a resolve notification for the active Alert?</p>
                <div className="px-2">
                  <RadioGroup
                    name="send_resolved_notifications"
                    value={sendResolvedNotifications}
                    options={[
                      {value: "true", label: "Yes, send a resolve notification"},
                      {value: "false", label: "No, do not send a resolve notification"},
                    ]}
                    onChange={setSendResolvedNotifications}
                  />
                </div>
              </>
            )}
          </div>
        )
      }
      mutation_GQL={GQL_UPDATE_CHECK_IS_PAUSED}
      mutation_variables={{
        ids: [id],
        is_paused: !isPaused,
        send_resolved_notifications: hasOngoingAlert && sendResolvedNotifications === "true",
      }}
      mutation_hook_options={{refetchQueries: [GQL_CHECK_DETAILS]}}
      data-testid="check-analysis-pause-btn"
    >
      <Icon icon={isPaused ? TbPlayerPlay : TbPlayerPause} />
      <span>{isPaused ? "Resume" : "Pause"}</span>
    </ButtonWithMutationAndConfirmationDialog>
  );
};
